// src/components/Dashboard/ContactAdmin.jsx
import React, { useState, useEffect } from 'react';
import { FiMail, FiTrash2, FiCheck, FiClock, FiPhone, FiUser } from 'react-icons/fi';
import { collection, onSnapshot, query, orderBy, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import './ContactAdmin.css';
import { db } from '../firebase/firebase-config';

function ContactAdmin() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Firestore'dan mesajları anlık (real-time) olarak çekiyoruz kanka
  useEffect(() => {
    const q = query(collection(db, 'contacts'), orderBy('date', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const msgList = snapshot.docs.map(docSnap => ({
        firebaseId: docSnap.id,
        ...docSnap.data()
      }));
      setMessages(msgList);
      setLoading(false);
    }, (error) => {
      console.error("Mesajlar yüklenirken hata oluştu:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Mesajı okundu olarak işaretleme
  const handleToggleRead = async (firebaseId, currentStatus) => {
    try {
      const msgRef = doc(db, 'contacts', firebaseId);
      await updateDoc(msgRef, {
        read: !currentStatus
      });
    } catch (error) {
      console.error("Güncelleme sırasında hata oluştu:", error);
    }
  };

  // Mesajı silme
  const handleDelete = async (firebaseId) => {
    if (window.confirm("Bu mesajı silmek istediğinize emin misiniz?")) {
      try {
        await deleteDoc(doc(db, 'contacts', firebaseId));
      } catch (error) {
        console.error("Mesaj silinirken hata oluştu:", error);
      }
    }
  };

  return (
    <div className="contact-admin-container">
      <div className="admin-section-header">
        <h3><FiMail /> İletişim Formu Mesajları ({messages.length})</h3>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', padding: '30px', color: 'var(--text-muted)' }}>Mesajlar yükleniyor...</p>
      ) : messages.length === 0 ? (
        <p className="no-blogs-text" style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '30px' }}>
          Henüz hiç mesaj alınmadı kanka.
        </p>
      ) : (
        <div className="messages-list-grid">
          {messages.map((msg) => (
            <div key={msg.firebaseId} className={`admin-message-card ${msg.read ? 'read' : 'unread'}`}>
              <div className="msg-header">
                <div className="msg-user-info">
                  <h4><FiUser /> {msg.name}</h4>
                  <span className="msg-subject">Konu: {msg.subject}</span>
                </div>
                <div className="msg-meta">
                  <span className="msg-date"><FiClock /> {new Date(msg.date).toLocaleDateString('tr-TR')} {new Date(msg.date).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>
                  <span className={`status-badge ${msg.read ? 'read-badge' : 'unread-badge'}`}>
                    {msg.read ? 'Okundu' : 'Yeni Mesaj'}
                  </span>
                </div>
              </div>

              <div className="msg-body">
                <p><strong>E-Posta:</strong> <a href={`mailto:${msg.email}`}>{msg.email}</a></p>
                <p><strong>Telefon:</strong> <a href={`tel:${msg.phone}`}><FiPhone /> {msg.phone}</a></p>
                <p className="msg-content-text">"{msg.message}"</p>
              </div>

              <div className="msg-actions">
                <button 
                  className={`read-toggle-btn ${msg.read ? 'unread-btn' : 'read-btn'}`} 
                  onClick={() => handleToggleRead(msg.firebaseId, msg.read)}
                >
                  <FiCheck /> {msg.read ? 'Okunmadı İşaretle' : 'Okundu Olarak İşaretle'}
                </button>
                <button className="delete-btn" onClick={() => handleDelete(msg.firebaseId)} title="Sil">
                  <FiTrash2 /> Sil
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContactAdmin;